<template>
  <base-container>
    <van-nav-bar title="订单" left-text="我的" left-arrow @click-left="$router.push('/about')" />
    <van-empty v-if="!hasData" description="未找到用户订单">
    </van-empty>
    <van-pull-refresh v-else v-model="refreshing" @refresh="onLoad">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <van-row v-for="(item,index) in list" :key="index">
          <van-cell
            style="background-color: #f7f8fa;"
            :title="getBusTypeName(item)"
            icon="chat-o"
            size="large"
            :label="item.createTime"
            is-link
            :to="'/orderdetail/'+item.billNo"
          >
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/'+item.busType+'.png')"
              />
            </template>
            <b style="color:#F98B34">
              <span v-text="item.amount"></span> 元
            </b>
            <div>
              <van-image
                style="ertical-align：middle;margin:0 5px;"
                width="12"
                height="12"
                :src="require('@/assets/img/'+item.payType+'.png')"
              />
              <span v-text="getPayTypeName(item)"></span>
            </div>
          </van-cell>
        </van-row>
      </van-list>
    </van-pull-refresh>
  </base-container>
</template>

<script>
import { getOrders } from "@/api/customer";
export default {
  data() {
    return {
      list: [],
      hasData:true,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  created(){
    this.onLoad();
  },
  methods: {
    onLoad() {
      getOrders().then((res) => {
        this.loading = false;
        this.list = res.data.value;
        if(this.list&&this.list.length>0){
          this.hasData=true;
        }else{
          this.hasData=false;
        }
        this.finished = true;
        this.refreshing=false;
      });
    },
    getPayTypeName(item) {
      var name = "未知";
      switch (item.payType) {
        case "WechatPay":
          name = "微信";
          break;
        case "AliPay":
          name = "支付宝";
          break;
      }
      return name;
    },
    getBusTypeName(item) {
      var name = "未知";
      switch (item.busType) {
        case "WaterRecharge":
          name = "水费充值";
          break;
        case "Register":
          name = "当日挂号";
          break;
        case "ReserveRegister":
          name = "预约挂号";
          break;
      }
      return name;
    },
  },
};
</script>

<style>
</style>